import request from '@/utils/request'
// 获取学期列表
export function getSemester(data) {
  return request({
    url: 'stats/common/semester',
    method: 'POST',
    data,
  })
}
// 获取学院列表
export function getCollege(data) {
  return request({
    url: 'stats/common/college',
    method: 'POST',
    data,
  })
}
// 获取角色列表
export function getRole(data) {
  return request({
    url: 'stats/common/role',
    method: 'POST',
    data,
  })
}
// 切换角色
export function setRole(data) {
  return request({
    url: 'stats/common/setRole',
    method: 'POST',
    data,
  })
}
// 获取用户信息
export function getUserInfo(data) {
  return request({
    url: 'stats/common/userInfo',
    method: 'POST',
    data,
  })
}
// 注销登录接口
export function logout(data) {
  return request({
    url: 'stats/common/logout',
    method: 'POST',
    data,
  })
}
